import { Message } from '../../../moderation/models/message';
import { IPageInfo, Tag } from '../state/types';

export function sortLockedItems(items: Array<Message>, pageInfo: IPageInfo): Array<Message> {
  const { sortBy } = pageInfo;

  if (sortBy === 'oldest') {
    return [...items].sort((a, b) => a.postedAt - b.postedAt);
  }

  if (sortBy === 'newest') {
    return [...items].sort((a, b) => b.postedAt - a.postedAt);
  }

  if (sortBy === 'safest') {
    return [...items].sort((a, b) => (b.safetyScore || 0) - (a.safetyScore || 0));
  }

  return items;
}

export function filterLockedItems(items: Array<Message>, pageInfo: IPageInfo): Array<Message> {
  const { tag: filterTag, messageType, published: publishedFilter } = pageInfo;

  return items.filter(({ published, type, tags }) => {
    if (messageType !== 'all' && type !== messageType) {
      return false;
    }

    if ((publishedFilter === 'true' && !published) || (publishedFilter === 'false' && published)) {
      return false;
    }

    if (filterTag.length === 1 && filterTag[0] === 'all') {
      return true;
    } else {
      return filterTag.every(t => {
        if (t === Tag.RESTRICTED_WORDS) {
          return tags.some(tag =>
            [
              Tag.RESTRICTED_WORDS,
              Tag.REJECTED_WORDS,
              Tag.PUBLISH_AND_MODERATE_WORDS,
              Tag.INVALID_CHARACTERS,
              'doxxing_words'
            ].includes(tag)
          );
        } else {
          return tags.includes(t);
        }
      });
    }
  });
}
